import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  signOut, 
  onAuthStateChanged,
  User 
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDj8-I-B4W47EYIiVXnGKlBdj6Bns-my50",
  authDomain: "heypm-511616.firebaseapp.com",
  projectId: "heypm-511616",
  storageBucket: "heypm-511616.firebasestorage.app",
  messagingSenderId: "362149611676",
  appId: "1:362149611676:web:c18ad38655ecb62ce38559",
  measurementId: "G-68EJ1YFMDB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Standard non-sensitive authentication
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export const loginWithGoogle = async (): Promise<User> => {
  const result = await signInWithPopup(auth, googleProvider);
  return result.user;
};

export const logoutUser = async (): Promise<void> => {
  await signOut(auth);
};

export { onAuthStateChanged };
export default app;
